import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SafetyDividerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"safety_divider"}/>
}
